module.exports = __webpack_public_path__ + "static/media/4.2fa7e91a.jpg";